module.exports = __webpack_public_path__ + "media/images/icon_crown04-1857e4b7faf0d4560ca1e797c4d9b86f.png";